/* pf-cc-gallery.js v8 - custom-cushion gallery: serves the gallery images at the size they are really
   rendered, keeps the current thumbnail in view inside the vertical strip, re-measures the main slider
   when its column width changes, and stops sideways drags on the strip from switching the main image.
   Pure enhancement; the gallery works without it. Kill switch: ?pf_cc_off=1
   The lightbox is deliberately untouched: Fancybox opens the full-resolution original from the href on
   the wrapping .media element, and this file never writes that href - only the <img> inside it. */
(function(){'use strict';
 if(window.__pfCcGallery)return; var STAT=window.__pfCcGallery={v:8,reverts:0,parked:0,held:0,slidesHeld:0,slidesReleased:0,releasedAll:0};
 if(/(?:^|[?&])pf_cc_off=1(?:&|$)/.test(location.search))return;
 var reduce=false; try{reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches}catch(e){}
 var SEC='[id^="ProductSection-template--"] ';

 /* ---------------------------------------------------------------- image weight
    Ella puts the untouched original in src, srcset, data-src and data-srcset of every gallery image:
    1536x1536 and 1588x2845 files dropped into a 316x395 box on a phone. Measured on Linen at 412px,
    1893 KB of gallery imagery for a stage 316 CSS px wide. Ask the CDN for the width the box actually
    uses - device pixels, capped at 2x and at the source image's own width - and the same picture costs
    a fraction of that (897 KB -> 156 KB for the worst offender). Aspect ratio is untouched: only a
    width is requested, so the CDN scales proportionally, and the width/height attributes keep
    describing the same ratio. Widths snap to a ladder so repeat views share CDN cache entries. */
 var LADDER=[180,240,320,420,520,640,760,900,1080,1280,1500,1800,2200];
 /* the eager first slide is sized in layout/theme.liquid instead, at parse time: this file is deferred
    and by the time it runs the preload scanner has already fetched the untouched original. The head
    script uses this same ladder and the same box*dpr formula, and stamps data-pf-w/data-pf-cap, so the
    sweeps below see an adequate width and leave that image alone. */
 function snap(w,cap){var i;for(i=0;i<LADDER.length;i++){if(LADDER[i]>=w)return Math.min(LADDER[i],cap)}return Math.min(LADDER[LADDER.length-1],cap)}
 /* Only real product/file media. Theme assets live at /cdn/shop/t/<n>/assets/ and do not take a width
    parameter, so they must never be rewritten - the trust-badge avatars sit in this same section. */
 function isCdn(u){
  if(!u)return false;
  if(!/\.(jpe?g|png|webp)$/i.test(u.split('?')[0].split('#')[0]))return false;
  return /\/cdn\/(?:shop|shopify)\/(?:files|products)\//.test(u)||/\/cdn\/s\/files\//.test(u);
 }
 /* Shopify's legacy named sizes (_medium, _grande, ...) are already downscaled files that ignore a
    width parameter - measured: _medium with &width=180 returns the identical 240px file, byte for byte.
    Rewriting one would fork the CDN cache key for no saving at all, so leave them as the theme wrote them. */
 /* numeric named sizes (_1200x on this page's sticky popup image, _150x150 on the logo) behave the
    same way: measured byte-identical at &width=180, &width=240 and &width=640, so a rewritten URL would
    only fork the CDN cache key. Match those too. */
 function namedSize(u){return /_(?:pico|icon|thumb|small|compact|medium|large|grande|\d{1,4}x\d{0,4})\.(?:jpe?g|png|webp)$/i.test(u.split('?')[0].split('#')[0])}
 /* ...but the MASTER a named size was generated from does take one, and for a thumbnail that is the last
    >2x oversize left on the page: the strip ships Shopify's 240px _medium derivative into a 56-64px box.
    Measured on Linen: _medium = 24,816 bytes, the same master at ?width=120 = 7,348 (-70%), and Linen
    has 26 thumbnails. Only thumbnails are swapped - elsewhere the named size is close enough to the box
    that forking the CDN cache key would cost more than it saves. If a master ever 404s (an image
    genuinely uploaded under a size-shaped name) the original attributes are put straight back by a
    one-shot error handler, so a missing file can never leave a broken thumbnail on the page. */
 var NAMED=/^(.*)_(?:pico|icon|thumb|small|compact|medium|large|grande|\d{1,4}x\d{0,4})(\.(?:jpe?g|png|webp))$/i;
 var LADDER_T=[120,180,240,320];
 function snapT(w,cap){var i;for(i=0;i<LADDER_T.length;i++){if(LADDER_T[i]>=w)return Math.min(LADDER_T[i],cap)}return Math.min(LADDER_T[LADDER_T.length-1],cap)}
 function master(u){if(!u)return null;var h=String(u).split('#'),q=h[0].split('?'),m=NAMED.exec(q[0]);return m?m[1]+m[2]+(q[1]?'?'+q[1]:''):null}
 function fallbackOn(img){
  if(img.getAttribute('data-pf-swap'))return; img.setAttribute('data-pf-swap','1');
  var o={src:img.getAttribute('src'),srcset:img.getAttribute('srcset'),'data-src':img.getAttribute('data-src'),'data-srcset':img.getAttribute('data-srcset')};
  img.addEventListener('error',function h(){try{img.removeEventListener('error',h);
   Object.keys(o).forEach(function(k){if(o[k]==null)img.removeAttribute(k);else img.setAttribute(k,o[k])});
   img.removeAttribute('data-pf-w');img.removeAttribute('data-pf-swap');}catch(e){}});
 }
 function atW(u,w){
  if(!isCdn(u)||namedSize(u))return null;
  var h=u.split('#'),p=h[0].split('?'),base=p[0];
  var q=(p[1]||'').split('&').filter(function(kv){return kv&&!/^(width|height)=/i.test(kv)});
  q.push('width='+w);
  return base+'?'+q.join('&');
 }
 /* one correctly sized candidate, so srcset can never disagree with src (Ella emits a single
    candidate with no descriptor; anything else would keep a descriptor that no longer matches). */
 function ssAt(v,w){if(!v)return null;return atW(String(v).split(',')[0].trim().split(/\s+/)[0],w)}
 /* A thumbnail must never inherit the stage's fallback width. The sticky bar's popup gallery keeps its
    thumbnails at 0x0 until it is opened and the theme hands them the untouched original as src: that is
    where this page's 810 KB, 215 KB and 188 KB downloads were coming from, for pictures never shown
    larger than 56px. Size a thumbnail from a thumbnail's own ceiling instead. */
 function isThumb(img){return !!(img.closest('.productView-thumbnail')||img.closest('.productView-stickyCart .sticky-image'))}
 /* img.complete below catches an image that has finished AND DECODED. Between responseEnd and decode
    there is a window where the bytes are already bought but complete is still false, and a rewrite in
    that window pays for the whole picture twice. Resource Timing records the entry at responseEnd, so
    it closes exactly that gap - the same test layout/theme.liquid uses on the eager slide. */
 /* The Resource Timing buffer is finite and these pages are past 250 entries by the time this file runs;
    once it is full getEntriesByName() stops seeing new downloads, while a PerformanceObserver still
    receives every one. So finished product images are also collected here, and spent() asks both. */
 /* A cancelled request is reported too - measured with status 0 and no body, and with status 200 and 300
    header bytes - so only a download with a 2xx/3xx status (where the browser exposes one) and a body
    counts. DONE keeps the earliest responseEnd of each such download, because a revert below needs to
    know WHEN it ended, not just that it did. */
 var DONE={},pend=[],HELD={};
 function absU(u){try{return new URL(String(u),location.href).href}catch(e){return String(u||'')}}
 /* a cross-origin entry without Timing-Allow-Origin reports no status and no sizes at all, so there only
    the existence of a finished entry can be judged - as before */
 function fin(e){if(!e||!(e.responseEnd>0))return false;
  if(String(e.name).indexOf(location.origin+'/')!==0)return true;
  return (e.responseStatus===undefined||(e.responseStatus>=200&&e.responseStatus<400))&&(e.encodedBodySize>0||e.decodedBodySize>0)}
 function endOf(u){if(!u)return -1;var a=absU(u),best=DONE[a]!=null?DONE[a]:-1;try{var e=performance.getEntriesByName(a),i;for(i=0;e&&i<e.length;i++){if(fin(e[i])&&(best<0||e[i].responseEnd<best))best=e[i].responseEnd}}catch(x){}return best}
 function spent(u){return endOf(u)>=0}
 /* A rewrite of an image that is still downloading is a bet that the cancel lands before the last byte.
    Measured cold at 412px it lost on 5 of 10 cushions for the four eager _medium strip thumbnails
    (chair 47,731 B, daybed 45,412 B, kids 30,920 B paid twice) and won cleanly on the other five, so the
    bet stays - but it no longer has to be paid twice when it loses. If the original reports a download
    that had already ENDED BEFORE the rewrite (responseEnd <= the rewrite's time) while the replacement has
    not arrived, put the original attributes back: that picture is whole and in memory, so it shows at
    once, and dropping the replacement's URL cancels the replacement while it is still open. The time
    bound keeps this safe: a download the rewrite itself cut off can be reported with status 200 and a
    partial body, but it always ends after the rewrite, so it is never mistaken for a finished picture
    and fetched again. If the replacement already arrived both are bought, so nothing is touched. */
 function settle(){
  for(var i=pend.length-1;i>=0;i--){var p=pend[i];
   var end=endOf(p.ou);
   if(end<0||end>p.t){if(Date.now()-p.at>20000){pend.splice(i,1)}continue}
   pend.splice(i,1);
   try{
    if(p.img.getAttribute('src')!==p.nu)continue;
    if((p.img.complete&&p.img.naturalWidth>0)||spent(p.nu))continue;
    Object.keys(p.o).forEach(function(k){if(p.o[k]==null)p.img.removeAttribute(k);else p.img.setAttribute(k,p.o[k])});
    p.img.setAttribute('data-pf-w',String(p.cap));
    STAT.reverts++;
   }catch(e){}
  }
 }
 try{if(window.PerformanceObserver){new PerformanceObserver(function(l){try{
   l.getEntries().forEach(function(e){if(isCdn(e.name)&&fin(e)&&(DONE[e.name]==null||e.responseEnd<DONE[e.name]))DONE[e.name]=e.responseEnd});
   if(pend.length)settle();
  }catch(e){}}).observe({type:'resource',buffered:true})}}catch(e){}
 function boxOf(img){
  var c=img.closest('.productView-img-container')||img.closest('.productView-thumbnail-link')||img.parentElement;
  var w=c?Math.round(c.getBoundingClientRect().width):0;
  /* the pre-layout fallback used to be a flat 64, which snaps to the 180 rung on a phone whose strip is
     56px wide - three thumbnails per load were sized 1.6x too big purely by measuring too early */
  if(isThumb(img)){return Math.min(160,Math.max(56,w||(window.innerWidth<768?56:64)))}
  if(!w){var n=document.querySelector(SEC+'.productView-images .productView-nav');w=n?Math.round(n.getBoundingClientRect().width):0}
  if(!w){w=Math.max(280,Math.min(window.innerWidth-96,700))} /* pre-layout fallback; a later pass upgrades */
  return w;
 }
 function sizeImg(img,fresh){
  try{
   if(img.hasAttribute('data-pf-park'))return;
   var cap=parseInt(img.getAttribute('data-pf-cap'),10);
   if(!cap){
    /* a thumbnail's width attribute describes the DERIVATIVE (240 for _medium), not the master it can be
       swapped to, so capping on it would clamp the request to a width that is not on any ladder */
    cap=(isThumb(img)?0:(parseInt(img.getAttribute('width'),10)||(img.naturalWidth>0?img.naturalWidth:0)))||4000;
    img.setAttribute('data-pf-cap',String(cap));
   }
   var cur=parseInt(img.getAttribute('data-pf-w'),10)||0;
   var th=isThumb(img),need=Math.round(boxOf(img)*Math.min(window.devicePixelRatio||1,2));
   var t=th?snapT(need,cap):snap(need,cap);
   /* An image that already finished downloading has spent its bytes; swapping it now only adds more.
      This used to be gated on !cur, so it stopped applying the moment an early sweep stamped a width -
      a later sweep that measured a wider box would then refetch the same photo at the larger size and
      pay for it twice (320 + 640 instead of 640). Judge it on what was actually delivered instead: a
      finished image is left alone whenever the pixels it already has cover the box it ended up in. */
   if(img.complete&&img.naturalWidth>0&&img.naturalWidth>=t){if(!cur)img.setAttribute('data-pf-w',String(cap));return}
   /* the bytes for this exact URL are already on the wire's far side - see spent() */
   if(!cur&&img.getAttribute('src')&&spent(img.src)){img.setAttribute('data-pf-w',String(cap));return}
   /* Never downgrade, and never pay for a whole second download to gain a little sharpness. The head
      script sizes the eager slide before layout, so it reads devicePixelRatio before the browser has
      settled on one; measured at 768 the ratio was 1 at parse time and 1.5 by the time this file
      measured the box, which asked for 640 over an already-delivered 520 and cost a second 89,389-byte
      request for 23% more linear resolution. Anything within 20% of the target is left alone - a
      genuinely short image (a bad estimate, or a real move to a retina screen) still upgrades. */
   if(t<=cur||cur>=t*0.8)return;
   var s1=atW(img.getAttribute('src'),t),s2=atW(img.getAttribute('data-src'),t),
       s3=ssAt(img.getAttribute('srcset'),t),s4=ssAt(img.getAttribute('data-srcset'),t),sw=false;
   /* 19 of Linen's 26 thumbnails are handed to lazysizes with data-srcset ALONE - no src and no
      data-src - so a guard that only looked at the two src attributes skipped them entirely and they
      went on unveiling the 240px _medium into a 56px box. Each of the four attributes is rewritten only
      when it is already present, so this never creates a src or srcset on an unveiled lazy image. */
   /* the gallery-thumbnail case below only reaches for the master when NOTHING resolved, because there
      a src is a lazysizes placeholder. The sticky bar's picture is different: it carries a real named
      size in src, so atW() correctly refuses it and every candidate is null - which lands here anyway. */
   if(th&&!s1&&!s2&&!s3&&!s4){
    s1=atW(master(img.getAttribute('src')),t); s2=atW(master(img.getAttribute('data-src')),t);
    s3=ssAt(master(String(img.getAttribute('srcset')||'').split(',')[0].trim().split(/\s+/)[0]),t);
    s4=ssAt(master(String(img.getAttribute('data-srcset')||'').split(',')[0].trim().split(/\s+/)[0]),t);
    sw=!!(s1||s2||s3||s4);
   }
   if(!s1&&!s2&&!s3&&!s4)return;
   var o={src:img.getAttribute('src'),srcset:img.getAttribute('srcset'),'data-src':img.getAttribute('data-src'),'data-srcset':img.getAttribute('data-srcset')};
   var live=!!(s1&&o.src&&isCdn(o.src)&&!img.complete);
   /* An eager picture the parser met long before this file ran is already on the wire, and past that
      point a rewrite does not stop it: measured cold on the daybed at 412px, the four _medium strip
      thumbnails had been requested at 1447ms, this file rewrote three of them at 2199ms while they were
      still arriving, and all three still finished (2199-2348ms) - two of the 120px copies were paid for
      on top (6,632 + 5,120 B). So an in-flight eager picture is left alone. The one exception is a node
      that is genuinely new (fresh from the observer below, which runs before its request starts): never
      one this file has already seen - slick MOVES the parser's nodes into its track, which reports them
      as added again - and never a clone sharing a URL that is already held. */
   if(live&&img.getAttribute('loading')!=='lazy'&&(!fresh||img.__pfOld||HELD[absU(o.src)])){STAT.held++;HELD[absU(o.src)]=1;img.__pfOld=1;return}
   if(sw)fallbackOn(img);
   img.setAttribute('data-pf-w',String(t));
   if(s2)img.setAttribute('data-src',s2);
   if(s4)img.setAttribute('data-srcset',s4);
   if(s3)img.setAttribute('srcset',s3);
   if(s1)img.setAttribute('src',s1);
   if(live){pend.push({img:img,o:o,ou:o.src,nu:s1,cap:cap,at:Date.now(),t:(window.performance&&performance.now)?performance.now():0});settle()}
  }catch(e){}
 }
 /* ---------------------------------------------------------------- sticky popup thumbnails
    The sticky bar carries a second 26-picture thumbnail slider inside its option popup. On these pages
    that popup can never open - its expand link and panel are hidden under html[data-pf-cc] because the
    panel holds the 250-truncated picker - yet every load still downloaded 3-6 of its pictures
    (measured on Linen at 412px: 5 requests at 2.77-2.82s, 11-34 KB per product). The cause is slick's
    infinite mode: it builds its clones with jQuery .clone(), and a clone is created detached, where
    loading="lazy" does not apply, so the first and last three slides were fetched for a panel that is
    display:none. Park the src of every popup thumbnail that is not rendered - clones then copy no src and
    fetch nothing. Anything rendered is unparked on the next sweep, and removing data-pf-cc (failOpen)
    unparks everything at once, so the stock slider is back exactly as the theme wrote it. */
 var PARK_SEL='.productView-stickyCart .sticky-product-mobile-content .productView-thumbnail img';
 function parkOn(){return document.documentElement.hasAttribute('data-pf-cc')}
 function unpark(im){
  var s=im.getAttribute('data-pf-park'),ss=im.getAttribute('data-pf-park-ss');
  if(s==null&&ss==null)return;
  im.removeAttribute('data-pf-park');im.removeAttribute('data-pf-park-ss');
  if(ss&&!im.hasAttribute('srcset'))im.setAttribute('srcset',ss);
  if(s&&!im.hasAttribute('src'))im.setAttribute('src',s);
 }
 function unparkAll(){try{var l=document.querySelectorAll('img[data-pf-park],img[data-pf-park-ss]');for(var i=0;i<l.length;i++)unpark(l[i])}catch(e){}}
 function park(){
  try{
   if(!parkOn()){unparkAll();return}
   var l=document.querySelectorAll(PARK_SEL),i,im,s,ss;
   for(i=0;i<l.length;i++){im=l[i];
    if(im.getClientRects().length){unpark(im);continue}
    s=im.getAttribute('src');ss=im.getAttribute('srcset');
    if(!s&&!ss)continue;
    if(im.complete&&im.naturalWidth>0)continue; /* already delivered - nothing left to save */
    if(s){im.setAttribute('data-pf-park',s);im.removeAttribute('src')}
    if(ss){im.setAttribute('data-pf-park-ss',ss);im.removeAttribute('srcset')}
    STAT.parked++;
   }
  }catch(e){}
 }
 try{new MutationObserver(function(){if(!parkOn())unparkAll()}).observe(document.documentElement,{attributes:true,attributeFilter:['data-pf-cc']})}catch(e){}
 var sweeps=0,saved=0;
 function sweep(){
  try{
   sweeps++;
   park();
   /* .sticky-image is the bar's own product picture. The theme hands it Shopify's _1200x derivative -
      276KB on Velvet - for a box that is 45px wide on a desktop and display:none on a phone, and it
      matched none of the selectors below, so nothing had ever sized it. It is a named size, so only the
      master takes a width parameter; master() + the thumbnail ladder is exactly that swap. */
   var l=document.querySelectorAll(SEC+'.productView-images .productView-nav img,'+SEC+'.productView-thumbnail img,'+
     SEC+'.productView-stickyCart .productView-nav img,.productView-stickyCart .productView-thumbnail img,'+
     SEC+'.productView-stickyCart .sticky-image img,.productView-stickyCart .sticky-image img');
   for(var i=0;i<l.length;i++){sizeImg(l[i]);l[i].__pfOld=1}
   saved=l.length;
  }catch(e){}
 }
 sweep();
 if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',sweep)}
 window.addEventListener('load',sweep);
 [200,700,1600,3200].forEach(function(ms){setTimeout(sweep,ms)});
 var swT; function sweepSoon(){clearTimeout(swT);swT=setTimeout(sweep,150)}
 window.addEventListener('resize',sweepSoon); window.addEventListener('orientationchange',sweepSoon);
 try{
  var ir=document.querySelector(SEC+'.productView-images');
  /* The head script in layout/theme.liquid cancels the preload scanner's full-size fetch, but it
     disconnects at DOMContentLoaded, so an eager gallery <img> inserted after that downloaded the
     untouched original (measured 401,198 bytes for an injected slide, uncancelled). Size an added image
     synchronously here too - this callback runs as a microtask, early enough to cancel - and keep the
     debounced sweep for the layout-dependent re-measure. Attribute writes are not observed (childList
     only), so this cannot feed itself. */
  if(ir&&window.MutationObserver){new MutationObserver(function(recs){
   try{for(var i=0;i<recs.length;i++){var a=recs[i].addedNodes;
    for(var j=0;j<a.length;j++){var x=a[j];
     if(!x||x.nodeType!==1)continue;
     if(x.tagName==='IMG'){sizeImg(x,true)}
     else if(x.querySelectorAll){var l=x.querySelectorAll('img');for(var k=0;k<l.length;k++){sizeImg(l[k],true)}}
    }}}catch(e){}
   sweepSoon();
  }).observe(ir,{childList:true,subtree:true})}
 }catch(e){}

 /* ---------------------------------------------------------------- strip + stage behaviour */
 function center(strip){try{
  var cs0=getComputedStyle(strip), oy=cs0.overflowY, ox=cs0.overflowX;
  var cur=strip.querySelector('.productView-thumbnail.slick-current:not(.slick-cloned)'); if(!cur)return;
  var s=strip.getBoundingClientRect(), c=cur.getBoundingClientRect();
  /* between 768 and 1023 the strip is a horizontal rail under the stage, so the current thumbnail has to
     be brought into view sideways instead - otherwise it just scrolls off a 26-thumbnail tablet rail. */
  if(ox==='auto'||ox==='scroll'){
   if(!s.width||!c.width)return;
   if(c.left<s.left||c.right>s.right){
    var sl=strip.scrollLeft, lf=Math.round(Math.max(0,Math.min(strip.scrollWidth-strip.clientWidth,sl+(c.left-s.left)-(s.width-c.width)/2)));
    if(strip.scrollTo&&!reduce){
     strip.scrollTo({left:lf,behavior:'smooth'});
     setTimeout(function(){if(strip.scrollLeft===sl)strip.scrollLeft=lf},700);
    }else{strip.scrollLeft=lf}
   }
   return;
  }
  if(oy!=='auto'&&oy!=='scroll')return;
  if(!s.height||!c.height)return;
  if(c.top<s.top||c.bottom>s.bottom){
   var start=strip.scrollTop, top=Math.round(Math.max(0,Math.min(strip.scrollHeight-strip.clientHeight,start+(c.top-s.top)-(s.height-c.height)/2)));
   if(strip.scrollTo&&!reduce){
    strip.scrollTo({top:top,behavior:'smooth'});
    setTimeout(function(){if(strip.scrollTop===start)strip.scrollTop=top},700); /* smooth scroll never started (e.g. hidden tab): jump */
   }else{strip.scrollTop=top}
  }
 }catch(e){}}
 /* v8: Ella appends a .slick-counter to the gallery root about a second after slick starts. A slick
    breakpoint refresh (a phone rotated across 768px, a window resized past it) re-reads that root's
    children, so the counter became slide 0: 21 slides against 20 thumbnails, the stage showed an empty
    box, and it stayed that way until reload. Measured on Linen 412x915 -> 915x412. Only
    .productView-image children are slides. Set on the live instance and on the settings a breakpoint
    refresh copies its options from; bound on 'init' before slick starts, so a rotation in the first
    seconds is covered too, and re-applied on every reInit/breakpoint. */
 function slideGuard(nav,$){try{
  function set(e,k){try{var s=k&&k.options?k:$(nav).slick('getSlick'); if(!s||!s.options)return;
   s.options.slide='.productView-image'; if(s.originalSettings)s.originalSettings.slide='.productView-image'}catch(x){}}
  if(!nav.hasAttribute('data-pf-slides')){nav.setAttribute('data-pf-slides','1'); $(nav).on('init.pfccs reInit.pfccs breakpoint.pfccs',set)}
  set();
 }catch(e){}}
 /* v8: the stage is a slick FADE slider, so every slide sits stacked in the same 316x395 box and
    lazysizes counts all of them as on screen: the moment slick started (window load) it unveiled the
    whole gallery. Measured cold on Linen at 412x915: slides 4-19 requested at 3.6-4.3s, about 1.5 MB,
    with no interaction at all. When slick starts, every slide further than one step from the current
    one gives up its lazyload class (data-pf-held marks it); it gets it back - and lazysizes unveils it
    at once - when a change heads for it or for a neighbour, so the next and previous photos are always
    already there. The first time the shopper actually uses the gallery (a slide change, a click, a key)
    everything still held is released, so from then on browsing is exactly as instant as before.
    Nothing is held if slick never starts, and any error releases everything. */
 function slideHold(root,nav,$){try{
  if(nav.hasAttribute('data-pf-hold'))return; nav.setAttribute('data-pf-hold','1');
  var all=false,allT=0;
  function slides(){return nav.querySelectorAll('.slick-track>.productView-image:not(.slick-cloned)')}
  function unveil(im){try{
   if(!im.hasAttribute('data-pf-held'))return;
   im.removeAttribute('data-pf-held'); STAT.slidesReleased++;
   im.classList.add('lazyload');
   if(window.lazySizes&&lazySizes.loader&&lazySizes.loader.unveil)lazySizes.loader.unveil(im);
  }catch(e){}}
  /* lazysizes writes the src a frame later, but the lightbox builds its thumbnail strip synchronously on
     the click that released everything; with no src on the slide it fell back to the full-size original
     for the thumbnail. Hand it the same sized URL the slide is about to load instead (one shared download). */
  function thumbFor(im){try{var a=im.closest('[data-fancybox]'); if(!a||a.hasAttribute('data-thumb'))return;
   var u=im.getAttribute('data-src')||String(im.getAttribute('data-srcset')||'').split(',')[0].trim().split(/\s+/)[0];
   if(u)a.setAttribute('data-thumb',u)}catch(e){}}
  function releaseAll(){if(all)return; all=true; STAT.releasedAll++; clearTimeout(allT);
   var l=nav.querySelectorAll('img[data-pf-held]'); for(var i=0;i<l.length;i++){thumbFor(l[i]);unveil(l[i])}}
  /* the photo being moved to goes first; everything else follows a moment later, so on a slow connection
     the one the shopper asked for is not queued behind sixteen others */
  function soon(){if(!all){clearTimeout(allT); allT=setTimeout(releaseAll,600)}}
  function onUse(e){try{if(e&&e.type==='click'){var l=nav.querySelectorAll('img[data-pf-held]');for(var i=0;i<l.length;i++)thumbFor(l[i])}}catch(x){} soon()}
  function release(idx){var l=slides(),n=l.length,k,s,im; if(!n)return;
   for(k=idx-1;k<=idx+1;k++){s=l[((k%n)+n)%n]; im=s&&s.querySelector('img[data-pf-held]'); if(im)unveil(im)}}
  function cur(){try{return $(nav).slick('slickCurrentSlide')||0}catch(e){return 0}}
  /* A slide moved to before its photo has arrived (a far thumbnail tapped as the very first move, on a slow
     connection) would show an empty stage until it does: Ella keeps a loading photo at opacity 0. Show the
     strip's own thumbnail of that same photo - already on screen, already downloaded - behind it instead,
     scaled like the photo, until the photo itself has loaded. Matched by file name, never by position. */
  function keyOf(u){if(!u)return '';u=String(u).split(',')[0].trim().split(/\s+/)[0];var m=master(u)||u;return m.split('#')[0].split('?')[0].split('/').pop()}
  function placeholder(slide){try{
   var im=slide&&slide.querySelector('img'),box=slide&&slide.querySelector('.productView-img-container');
   if(!im||!box||box.hasAttribute('data-pf-ph'))return;
   if(im.getAttribute('src')&&im.complete&&im.naturalWidth>0)return;
   var k=keyOf(im.getAttribute('data-src')||im.getAttribute('data-srcset')||im.getAttribute('src')); if(!k)return;
   var th=root.querySelectorAll('.productView-thumbnail-wrapper .productView-thumbnail img'),i,t,u=null;
   for(i=0;i<th.length;i++){t=th[i]; if(t.complete&&t.naturalWidth>0&&t.currentSrc&&keyOf(t.currentSrc)===k){u=t.currentSrc;break}}
   if(!u||/["'()\s]/.test(u))return;
   box.setAttribute('data-pf-ph','1'); box.style.backgroundImage='url('+u+')'; STAT.placeholders=(STAT.placeholders||0)+1;
   var done=function(){im.removeEventListener('load',done);im.removeEventListener('error',done);
    setTimeout(function(){box.style.backgroundImage='';box.removeAttribute('data-pf-ph')},400)};
   im.addEventListener('load',done); im.addEventListener('error',done);
  }catch(e){}}
  function hold(){
   if(all)return;
   var l=slides(),n=l.length,c=cur(),i,d,im;
   for(i=0;i<n;i++){d=Math.abs(i-c); d=Math.min(d,n-d); if(d<=1)continue;
    im=l[i].querySelector('img.lazyload'); if(!im)continue;
    im.classList.remove('lazyload'); im.setAttribute('data-pf-held','1'); STAT.slidesHeld++;
   }
  }
  function safe(fn){return function(e,s,a,b){try{fn(e,s,a,b)}catch(x){releaseAll()}}}
  $(nav).on('init.pfcch',safe(function(){hold();release(cur())}))
   .on('reInit.pfcch',safe(function(){release(cur())}))
   .on('beforeChange.pfcch',safe(function(e,s,from,to){placeholder(slides()[to]); release(to); soon()}))
   .on('afterChange.pfcch',safe(function(e,s,i){release(i)}));
  if(nav.classList.contains('slick-initialized')){hold();release(cur())}
  ['click','keydown','focusin'].forEach(function(t){root.addEventListener(t,onUse,true)});
  /* a lightbox, the zoom button or anything else that reads the photos from outside the gallery */
  document.addEventListener('fancybox:init',releaseAll); window.addEventListener('beforeprint',releaseAll);
  window.pfCcGalleryRelease=releaseAll;
 }catch(e){try{var l=nav.querySelectorAll('img[data-pf-held]');for(var i=0;i<l.length;i++){l[i].removeAttribute('data-pf-held');l[i].classList.add('lazyload')}}catch(x){}}}
 function boot(n){try{
  var $=window.jQuery, root=document.querySelector(SEC+'.productView-images'); if(!root||!$)return;
  var nav=root.querySelector('.productView-nav'), strip=root.querySelector('.productView-thumbnail-wrapper .productView-for'); if(!nav||!strip)return;
  slideGuard(nav,$); slideHold(root,nav,$);
  if(!nav.classList.contains('slick-initialized')||!strip.classList.contains('slick-initialized')){if(n<40)setTimeout(function(){boot(n+1)},250);return}
  if(root.hasAttribute('data-pf-enhanced'))return; root.setAttribute('data-pf-enhanced','gallery');
  var heals=0;
  function heal(){try{ /* slick keeps the width it measured at init; if the column width changed without a window-width change, re-measure exactly as a resize would */
   var s=$(nav).slick('getSlick'), w=s&&s.$list?s.$list.width():0;
   if(w>0&&Math.abs((s.listWidth||0)-w)>1){heals++;$(nav).slick('setPosition');sweepSoon()}
  }catch(e){}}
  var ht; function healSoon(){clearTimeout(ht);ht=setTimeout(heal,120)}
  var t; function later(){clearTimeout(t);t=setTimeout(function(){heal();center(strip);sweep()},30)}
  $(nav).on('afterChange.pfcc reInit.pfcc',later); $(strip).on('afterChange.pfcc',later); heal(); center(strip);
  try{var list=nav.querySelector('.slick-list'); if(list&&window.ResizeObserver){new ResizeObserver(healSoon).observe(list)}}catch(e){}
  window.addEventListener('resize',healSoon); window.addEventListener('orientationchange',healSoon); window.addEventListener('pageshow',healSoon);
  document.addEventListener('visibilitychange',function(){if(!document.hidden)healSoon()});
  setTimeout(heal,1500); setTimeout(heal,3500);
  if(document.readyState!=='complete'){window.addEventListener('load',function(){heal();center(strip)})}
  /* Our CSS turns the strip into a natively scrolling vertical column, but underneath it is still a
     horizontal slick slider wired asNavFor the main image, so a sideways drag across the thumbnails
     used to swipe the main stage. Two independent guards, because either one alone can be undone by a
     slick re-init: swipe/draggable/touchMove are switched off on the strip's own instance (slick reads
     these at event time), and drags that start on the strip are stopped before they reach slick's
     handlers. Clicks, taps and native vertical scrolling are untouched. */
  function lockStrip(){try{
   var s=$(strip).slick('getSlick');
   if(!s||s.options.swipe===false)return;
   $(strip).slick('slickSetOption','swipe',false,false);
   $(strip).slick('slickSetOption','draggable',false,false);
   $(strip).slick('slickSetOption','touchMove',false,false);
  }catch(e){}}
  lockStrip(); $(strip).on('reInit.pfcc init.pfcc',function(){setTimeout(lockStrip,0)}); setTimeout(lockStrip,1200);
  function stop(e){if(e.type==='mousedown'&&e.button!==0)return; e.stopPropagation()}
  if(!strip.hasAttribute('data-pf-nodrag')){
   strip.setAttribute('data-pf-nodrag','1');
   try{strip.addEventListener('touchstart',stop,{capture:true,passive:true})}catch(e){strip.addEventListener('touchstart',stop,true)}
   strip.addEventListener('mousedown',stop,true);
   strip.addEventListener('dragstart',stop,true);
  }
  window.pfCcGallery={version:'8',reverts:function(){return STAT.reverts},parked:function(){return STAT.parked},unpark:unparkAll,center:function(){center(strip)},heal:heal,heals:function(){return heals},
   sweep:sweep,sweeps:function(){return sweeps},sized:function(){return saved},lockStrip:lockStrip};
 }catch(e){try{console.warn('[pf-cc-gallery]',e)}catch(_){}}}
 if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',function(){boot(0)})}else{boot(0)}
})();
